import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import type { BlogPostData, BlogPostList } from "@/lib/opinly";

export const listBlogPosts = createServerFn({ method: "GET" })
  .inputValidator((data: unknown) =>
    z
      .object({
        limit: z.number().int().min(1).max(50).default(12),
        cursor: z.string().max(512).optional(),
      })
      .parse(data ?? {}),
  )
  .handler(async ({ data }): Promise<BlogPostList> => {
    const { fetchPosts } = await import("@/lib/opinly.server");
    return (await fetchPosts({ limit: data.limit, cursor: data.cursor })) as BlogPostList;
  });

export const getBlogPost = createServerFn({ method: "GET" })
  .inputValidator((data: unknown) => z.object({ slug: z.string().min(1).max(256) }).parse(data))
  .handler(async ({ data }): Promise<BlogPostData | null> => {
    const { fetchPost } = await import("@/lib/opinly.server");
    return (await fetchPost(data.slug)) as BlogPostData | null;
  });
